import React from "react";
import {ConsentDocumentSignatory, ConsentSignatoryState} from "@source/api/models/consentModels";
import {getConsentRoleProgress} from "@source/api/models/consentHelpers";
import styles from "./consentShared.module.scss";

const stateLabel: Record<ConsentSignatoryState, string> = {
  [ConsentSignatoryState.ACTIVE]: "Ready to sign",
  [ConsentSignatoryState.WAITING]: "Waiting",
  [ConsentSignatoryState.SIGNED]: "Signed",
};

export const SignatoryProgress = ({
  signatories,
  compact = false,
}: {
  signatories?: ConsentDocumentSignatory[];
  compact?: boolean;
}) => {
  const groups = getConsentRoleProgress(signatories);
  if (!signatories?.length || !groups.length) {
    return <span className={styles.unavailable}>No signaturies yet</span>;
  }

  return (
    <div className={`${styles.progress} ${compact ? styles.progressCompact : ""}`}>
      {groups.map((group) => (
        <section className={styles.progressGroup} key={group.role} aria-label={`${group.label} signing progress`}>
          <div className={styles.progressHeading}>
            <span>{group.label}</span>
            <span>{group.signed} of {group.total} signed</span>
          </div>
          <div className={styles.progressBar} aria-hidden="true">
            <span style={{width: `${(group.signed / group.total) * 100}%`}}/>
          </div>
          {!compact && (
            <div className={styles.people}>
              {signatories
                .filter((signatory) => signatory.role === group.role)
                .map((signatory) => (
                  <div className={styles.person} key={`${signatory.role}-${signatory.id}`}>
                    <span className={styles.personName}>{signatory.name}</span>
                    <span className={`${styles.personState} ${styles[`personState_${signatory.state}`]}`}>
                      {stateLabel[signatory.state]}
                    </span>
                  </div>
                ))}
            </div>
          )}
        </section>
      ))}
    </div>
  );
};
